import { fmtDayLabel } from "./_format";

// Pure grouping: turns a flat message array into a render-ready list with
// day separators + per-group avatar / timestamp flags.
export function groupMessagesForRender(messages) {
  const out = [];
  let lastDay = "";
  let lastSender = "";
  messages.forEach((m, idx) => {
    const day = (m.created_at || "").slice(0, 10);
    if (day !== lastDay) {
      out.push({ kind: "day", id: `day-${day}-${idx}`, label: fmtDayLabel(m.created_at) });
      lastDay = day;
      lastSender = "";
    }
    const next = messages[idx + 1];
    const isLastOfGroup = !next
      || next.sender_id !== m.sender_id
      || (next.created_at || "").slice(0, 10) !== day;
    const showAvatar = m.sender_id !== lastSender;
    lastSender = m.sender_id;
    out.push({ kind: "msg", id: m.id, msg: m, isLastOfGroup, showAvatar });
  });
  return out;
}

// Returns the id of the last message sent by `myId`, or null. Used to
// anchor the "seen" tick which only renders on the newest owned bubble.
export function findLastMineId(messages, myId) {
  for (let i = messages.length - 1; i >= 0; i--) {
    if (messages[i].sender_id === myId) return messages[i].id;
  }
  return null;
}
